export const _configFr = {
    informations: 'Informations de la partie',
    configure: 'Configuration',
    buildings: 'Bâtiments',
    vehiclesModels: 'Modèles de véhicules',
    btnBack: 'Retour au module',
    missions: 'Interventions',
    moreInfos: 'Plus d\'informations',
    gameInfosTitle: 'Nom et description de votre partie',
    gameNameTitle: 'Nom de la partie',
    update: 'Modifier',
    gameNameInfos: 'Le nom de la partie ne doit pas comporter de charactère spéciaux et ne doit pas dépasser une taille maximum de 35 charactères.',
    gameDescriptionTitle: 'Description de la partie',
    gameDescriptionInfos: 'La description ne doit pas dépasser 150 charactères.',
    gameAccessTitle: 'Configurer les accès à la partie',
    gamePublicTitle: 'Partie publique',
    gameRecruitmentTitle: 'Recrutement ouvert',
    gamePublicInfos: 'Lorsque la partie est privée, les joueurs peuvent demander l\'accès avec un code depuis leur gestion de compte.' +
        '\nVotre code d\'invitation: ',
    gameRecruitmentInfos: 'Lorsque le recrutement de la partie est fermée, personne ne peut rejoindre la partie, même avec un code d\'invitation.',
    delete: 'Supprimer la partie',
    deleteConfirm: 'Êtes vous sûr de vouloir supprimer votre partie ? Cette action est irréversible !',
    skillsFunctions: 'Compétences et fonctions',
    skills: 'Compétences',
    skill: 'Compétence',
    status: 'Statuts',
    services: 'Services',
    sig: 'Système d\'information géographique',
    accept: 'Accepter',
    refuse: 'Refuser',
    manage: 'Gérer',
    create: 'Créer',
    add: 'Ajouter',
    required: 'Obligatoire',
    optional: 'Facultatif',
    copyClipboard: 'Copier dans le press-papier',
    needUpdate: 'Ce contenu nécessite d\'être mis à jour pour fonctionner correctement',
    options: 'Options',
    apiKey: 'Clé API',

    players: 'Joueurs',
    player: 'Joueur',
    deletePlayer: 'Supprimer le joueur',
    deleteConfirmPlayer: 'Êtes vous sûr de vouloir supprimer ce joueur ? Cette action est irréversible !',
    managePlayer: 'Gestion du joueur',
    waitingPlayerTitle: 'Joueur en attente de rejoindre votre partie',
    waitingPlayersTitle: 'Joueurs en attente de rejoindre votre partie',
    waitingPlayersInfos: 'Joueurs en attente voulant rejoindre la partie',
    administrator: 'Administrateur',
    operator: 'Opérateur',
    alias: 'Alias',
    assignments: 'Affectations',

    addNewBuilding: 'Ajouter un nouveau bâtiment',
    noBuilding: 'Votre partie ne possède actuellement aucun bâtiment',
    buildingName: 'Nom du bâtiment',
    buildingAddress: 'Adresse du bâtiment',
    manageBuilding: 'Gestion de votre bâtiment',
    deleteBuilding: 'Supprimer le bâtiment',
    deleteConfirmBuilding: 'Êtes vous sûr de vouloir supprimer ce bâtiment ? Cette action est irréversible !',
    manageCars: 'Gestion des véhicules',
    noVehicles: 'Aucun véhicule n\'est actuellement associé à ce bâtiment',
    addNewVehicle: 'Ajouter un nouveau véhicule',
    vehicleName: 'Nom du véhicule',
    manageVehicle: 'Gestion du véhicule',
    deleteVehicle: 'Supprimer le véhicule',
    deleteConfirmVehicle: 'Êtes vous sûr de vouloir supprimer ce véhicule ? Cette action est irréversible !',
    manageStaff: 'Gestion du personnel',

    noVehicleModel: 'Votre partie ne possède actuellement aucun modèle de véhicule',
    vehicleModelName: 'Nom du modèle de véhicule',
    manageVehicleModel: 'Gestion du modèle de véhicule',
    addNewVehicleModel: 'Ajouter un nouveau modèle de véhicule',
    functions: 'Fonctions',
    functionsInvalid: 'Les fonctions ne sont pas valides.',
    createNewFunction: 'Créer une nouvelle fonction',
    functionName: 'Nom de la fonction',
    vehicleModelSkillsList: 'Liste des compétences du  modèle de véhicule',
    createNewSkill: 'Créer une nouvelle compétence',
    skillName: 'Nom de la compétence',
    manageVehicleModel: 'Gestion du modèle',
    deleteVehicleModel: 'Supprimer le modèle de véhicule',
    deleteConfirmVehicleModel: 'Êtes vous sûr de vouloir supprimer ce modèle ? Cette action est irréversible !',

    noFunction: 'Vous ne possédez actuellement aucune fonction de véhicule',
    addNewFunction: 'Créer une nouvelle fonction de véhicule',
    noSkill: 'Vous ne possédez actuellement aucune compétence de personnel',
    addNewSkill: 'Créer une nouvelle compétence de personnel',

    addNewStatus: 'Créer un nouveau statut',
    statusName: 'Nom du Statut',
    statusCode: 'Code du Statut',
    backgroundColor: 'Couleur de fond',
    textColor: 'Couleur du texte',
    deleteStatus: 'Supprimer le statut',
    deleteConfirmStatus: 'Êtes vous sûr de vouloir supprimer ce statut ? Cette action est irreversible !',
    manageStatus: 'Gestion d\'un statut',
    informativeDescription: 'Informatif (ne modifie pas le statut du véhicule)',
    informative: 'Informatif',
    statusReport: 'État du statut',

    addNewService: 'Créer un nouveau service',
    services: 'Services',
    serviceName: 'Nom du service',
    deleteService: 'Supprimer le service',
    deleteConfirmService: 'Êtes vous sûr de vouloir supprimer ce service ? Cette action est irreversible !',
    manageService: 'Gestion d\'un service',

    manageSkill: 'Gestion d\'une compétence',
    deleteSkill: 'Supprimer la compétence',
    deleteConfirmSkill: 'Êtes vous sûr de vouloir supprimer cette compétence ? Cette action est irreversible !',

    manageFunction: 'Gestion d\'une fonction',
    deleteFunction: 'Supprimer la fonction',
    deleteConfirmFunction: 'Êtes vous sûr de vouloir supprimer cette fonction ? Cette action est irreversible !',

    ranks: 'Grades',
    rankName: 'Nom du grade',
    addNewRank: 'Ajout d\'un nouveau grade',
    authorizations: 'Autorisations',
    deleteRank: 'Supprimer le grade',
    deleteConfirmRank: 'Êtes vous sûr de vouloir supprimer ce grade ? Cette action est irreversible !',

    addIncidentType: 'Ajouter un nouveau type d\'incident',
    incidentTypes: 'Natures de fait',
    categories: 'Catégories',
    reasons: 'Motifs',
    places: 'Lieux',
    response: 'Réponse',
    incidentCategory: 'Catégorie de l\'incident',
    incidentReason: 'Motif de l\'incident',
    incidentPlace: 'Lieu de l\'incident',
    incidentResponse: 'Réponse à l\'incident',
    servicesToContact: 'Services à contacter',
    addService: 'Ajouter un service',
    noService: 'Aucun service n\'est actuellement associé à ce type d\'incident',
    noServiceAvailable: 'Aucun service disponible',
    noResponse: 'Aucune réponse n\'est actuellement associée à ce type d\'incident',
    or: 'ou',

    interventionGroups: 'Groupes d\'intervention',
};

export const _configEn = {
    informations: 'Game informations',
    configure: 'Configure',
    buildings: 'Buildings',
    vehiclesModels: 'Vehicles models',
    btnBack: 'Back to mod',
    missions: 'Missions',
    moreInfos: 'More informations',
    gameInfosTitle: 'Name and description of your game',
    gameNameTitle: 'Name of the game',
    update: 'Update',
    gameNameInfos: 'The name of the game must not include special characters and must not exceed a maximum size of 35 characters.',
    gameDescriptionTitle: 'Description of the game',
    gameDescriptionInfos: 'The description should not exceed 150 characters.',
    gameAccessTitle: 'Configure game access',
    gamePublicTitle: 'Public game',
    gameRecruitmentTitle: 'Recruitment open',
    gamePublicInfos: 'When the game is private, players can request access with a code from their account management.\nYour invite code: ',
    gameRecruitmentInfos: 'When game recruitment is closed, no one can join the game, even with an invite code.',
    delete: 'Delete the game',
    deleteConfirm: 'Are you sure you want to delete your game? This action is irreversible!',
    skillsFunctions: 'Skills and functions',
    skills: 'Skills',
    skill: 'Skill',
    status: 'Status',
    services: 'Services',
    sig: 'Geographic Information System',
    accept: 'Accept',
    refuse: 'Refuse',
    required: 'Required',
    optional: 'Optional',
    manage: 'Manage',
    create: 'Create',
    add: 'Add',
    copyClipboard: 'Copy to clipboard',
    needUpdate: 'This content needs to be updated to work properly',
    options: 'Options',
    apiKey: 'API Key',

    players: 'Players',
    deletePlayer: 'Delete player',
    deleteConfirmPlayer: 'Are you sure you want to delete this player ? This action is irreversible!',
    managePlayer: 'Manage the player',
    waitingPlayerTitle: 'Player waiting to join your game',
    waitingPlayersTitle: 'Players waiting to join your game',
    administrator: 'Administrator',
    operator: 'Operator',
    alias: 'Alias',
    assignments: 'Assignments',

    addNewBuilding: 'Add new building',
    noBuilding: 'Your game currently has no buildings',
    buildingName: 'Building name',
    buildingAddress: 'Building address',
    manageBuilding: 'Manage your building',
    deleteBuilding: 'Delete building',
    deleteConfirmBuilding: 'Are you sure you want to delete this building? This action is irreversible!',
    manageCars: 'Manage vehicles',
    noVehicles: 'No vehicle is currently associated with this building',
    addNewVehicle: 'Add a new vehicle',
    vehicleName: 'Vehicle name',
    manageVehicle: 'Manage your vehicle',
    deleteVehicle: 'Delete vehicle',
    deleteConfirmVehicle: 'Are you sure you want to delete this vehicle? This action is irreversible !',
    manageStaff: 'Manage staff',

    waitingPlayersInfos: 'Waiting Players wanting to join the game',
    noVehicleModel: 'Your party currently has no vehicle model',
    vehicleModelName: 'Vehicle model name',
    manageVehicleModel: 'Vehicle model management',
    addNewVehicleModel: 'Add new vehicle model',
    functions: 'Functions',
    functionsInvalid: 'Functions are invalid.',
    createNewFunction: 'Create new function',
    functionName: 'Function Name',
    vehicleModelSkillsList: 'Vehicle Model Skill List',
    createNewSkill: 'Create a new skill',
    skillName: 'Skill name',
    manageVehicleModel: 'Model management',
    deleteVehicleModel: 'Delete vehicle model',
    deleteConfirmVehicleModel: 'Are you sure you want to delete this model? This action is irreversible !',

    noFunction: 'You currently have no vehicle functions',
    addNewFunction: 'Create a new vehicle function',
    noSkill: 'You currently have no staff skills',
    addNewSkill: 'Create new staff skill',

    addNewStatus: 'Add new status',
    statusName: 'Status name',
    statusCode: 'Status code',
    backgroundColor: 'Background color',
    textColor: 'Text color',
    deleteStatus: 'Delete status',
    deleteConfirmStatus: 'Are you sure you want to delete this status? This action is irreversible !',
    manageStatus: 'Manage your status',
    informativeDescription: 'Informative (does not modify the status of the vehicle)',
    informative: 'Informative',
    statusReport: 'Status report',

    addNewService: 'Add new service',
    services: 'Services',
    serviceName: 'Service name',
    deleteService: 'Delete service',
    deleteConfirmService: 'Are you sure you want to delete this service? This action is irreversible !',
    manageService: 'Manage your service',

    manageSkill: 'Manage your skill',
    deleteSkill: 'Delete skill',
    deleteConfirmSkill: 'Are you sure you want to delete this skill? This action is irreversible !',

    manageFunction: 'Manage your function',

    ranks: 'Ranks',
    rankName: 'Rank name',
    addNewRank: 'Add new rank',
    authorizations: 'Authorizations',
    deleteRank: 'Delete rank',
    deleteConfirmRank: 'Are you sure you want to delete this rank? This action is irreversible !',

    addIncidentType: 'Add new incident type',
    incidentTypes: 'Incident types',
    categories: 'Categories',
    reasons: 'Reasons',
    places: 'Places',
    response: 'Response',
    incidentCategory: 'Incident category',
    incidentReason: 'Incident reason',
    incidentPlace: 'Incident place',
    incidentResponse: 'Incident response',
    servicesToContact: 'Services to contact',
    addService: 'Add service',
    noService: 'No service is currently associated with this incident type',
    noServiceAvailable: 'No service available',
    noResponse: 'No response is currently associated with this incident type',
    or: 'or',

    interventionGroups: 'Intervention groups',
};

export const _configDe = {
    informations: 'Spielinformationen',
    configure: 'Konfiguration',
    buildings: 'Gebäude',
    vehiclesModels: 'Fahrzeugmodelle',
    btnBack: 'Zurück zum Modul',
    missions: 'Einsätze',
    moreInfos: 'Mehr Informationen',
    gameInfosTitle: 'Name und Beschreibung Ihres Spiels',
    gameNameTitle: 'Name des Spiels',
    update: 'Bearbeiten',
    gameNameInfos: 'Der Name des Spiels darf keine Sonderzeichen enthalten und darf maximal 35 Zeichen lang sein.',
    gameDescriptionTitle: 'Beschreibung des Spiels',
    gameDescriptionInfos: 'Die Beschreibung darf maximal 150 Zeichen lang sein.',
    gameAccessTitle: 'Zugriffskonfiguration für das Spiel',
    gamePublicTitle: 'Öffentliches Spiel',
    gameRecruitmentTitle: 'Offene Rekrutierung',
    gamePublicInfos: 'Wenn das Spiel privat ist, können Spieler mit einem Code über ihre Kontoverwaltung Zugriff anfordern.' +
        '\nIhr Einladungscode: ',
    gameRecruitmentInfos: 'Wenn die Rekrutierung für das Spiel geschlossen ist, kann niemand dem Spiel beitreten, selbst mit einem Einladungscode.',
    delete: 'Spiel löschen',
    deleteConfirm: 'Sind Sie sicher, dass Sie Ihr Spiel löschen möchten? Diese Aktion ist unwiderruflich!',
    skillsFunctions: 'Fähigkeiten und Funktionen',
    skills: 'Fähigkeiten',
    skill: 'Fähigkeit',
    status: 'Status',
    services: 'Dienste',
    sig: 'Geografisches Informationssystem',
    accept: 'Akzeptieren',
    refuse: 'Ablehnen',
    manage: 'Verwalten',
    create: 'Erstellen',
    add: 'Hinzufügen',
    required: 'Erforderlich',
    optional: 'Optional',
    copyClipboard: 'In die Zwischenablage kopieren',
    needUpdate: 'Dieser Inhalt muss aktualisiert werden, um ordnungsgemäß zu funktionieren',
    options: 'Optionen',
    apiKey: 'API-Schlüssel',

    players: 'Spieler',
    player: 'Spieler',
    deletePlayer: 'Spieler löschen',
    deleteConfirmPlayer: 'Sind Sie sicher, dass Sie diesen Spieler löschen möchten? Diese Aktion ist unwiderruflich!',
    managePlayer: 'Spieler verwalten',
    waitingPlayerTitle: 'Spieler wartet auf Beitritt zu Ihrem Spiel',
    waitingPlayersTitle: 'Spieler warten auf Beitritt zu Ihrem Spiel',
    waitingPlayersInfos: 'Spieler, die dem Spiel beitreten möchten',
    administrator: 'Administrator',
    operator: 'Operator',
    alias: 'Alias',
    assignments: 'Zuweisungen',

    addNewBuilding: 'Neues Gebäude hinzufügen',
    noBuilding: 'Ihr Spiel hat derzeit keine Gebäude',
    buildingName: 'Gebäudename',
    buildingAddress: 'Gebäudeadresse',
    manageBuilding: 'Gebäudeverwaltung',
    deleteBuilding: 'Gebäude löschen',
    deleteConfirmBuilding: 'Sind Sie sicher, dass Sie dieses Gebäude löschen möchten? Diese Aktion ist unwiderruflich!',
    manageCars: 'Fahrzeuge verwalten',
    noVehicles: 'Derzeit sind diesem Gebäude keine Fahrzeuge zugeordnet',
    addNewVehicle: 'Neues Fahrzeug hinzufügen',
    vehicleName: 'Fahrzeugname',
    manageVehicle: 'Fahrzeugverwaltung',
    deleteVehicle: 'Fahrzeug löschen',
    deleteConfirmVehicle: 'Sind Sie sicher, dass Sie dieses Fahrzeug löschen möchten? Diese Aktion ist unwiderruflich!',
    manageStaff: 'Personalverwaltung',

    noVehicleModel: 'Ihr Spiel hat derzeit keine Fahrzeugmodelle',
    vehicleModelName: 'Name des Fahrzeugmodells',
    manageVehicleModel: 'Fahrzeugmodellverwaltung',
    addNewVehicleModel: 'Neues Fahrzeugmodell hinzufügen',
    functions: 'Funktionen',
    functionsInvalid: 'Die Funktionen sind ungültig.',
    createNewFunction: 'Neue Funktion erstellen',
    functionName: 'Funktionsname',
    vehicleModelSkillsList: 'Liste der Fähigkeiten des Fahrzeugmodells',
    createNewSkill: 'Neue Fähigkeit erstellen',
    skillName: 'Fähigkeitsname',
    manageVehicleModel: 'Modellverwaltung',
    deleteVehicleModel: 'Fahrzeugmodell löschen',
    deleteConfirmVehicleModel: 'Sind Sie sicher, dass Sie dieses Modell löschen möchten? Diese Aktion ist unwiderruflich!',

    noFunction: 'Sie haben derzeit keine Fahrzeugfunktionen',
    addNewFunction: 'Neue Fahrzeugfunktion erstellen',
    noSkill: 'Sie haben derzeit keine Personalqualifikationen',
    addNewSkill: 'Neue Personalqualifikation erstellen',

    addNewStatus: 'Neuen Status erstellen',
    statusName: 'Statusname',
    statusCode: 'Statuscode',
    backgroundColor: 'Hintergrundfarbe',
    textColor: 'Textfarbe',
    deleteStatus: 'Status löschen',
    deleteConfirmStatus: 'Sind Sie sicher, dass Sie diesen Status löschen möchten? Diese Aktion ist unwiderruflich!',
    manageStatus: 'Statusverwaltung',
    informativeDescription: 'Informativ (ändert den Fahrzeugstatus nicht)',
    informative: 'Informativ',
    statusReport: 'Statusbericht',

    addNewService: 'Neuen Dienst erstellen',
    services: 'Dienste',
    serviceName: 'Dienstname',
    deleteService: 'Dienst löschen',
    deleteConfirmService: 'Sind Sie sicher, dass Sie diesen Dienst löschen möchten? Diese Aktion ist unwiderruflich!',
    manageService: 'Dienstverwaltung',

    manageSkill: 'Fähigkeitsverwaltung',
    deleteSkill: 'Fähigkeit löschen',
    deleteConfirmSkill: 'Sind Sie sicher, dass Sie diese Fähigkeit löschen möchten? Diese Aktion ist unwiderruflich!',

    manageFunction: 'Funktionsverwaltung',
    deleteFunction: 'Funktion löschen',
    deleteConfirmFunction: 'Sind Sie sicher, dass Sie diese Funktion löschen möchten? Diese Aktion ist unwiderruflich!',

    ranks: 'Ränge',
    rankName: 'Rangname',
    addNewRank: 'Neuen Rang hinzufügen',
    authorizations: 'Berechtigungen',
    deleteRank: 'Rang löschen',
    deleteConfirmRank: 'Sind Sie sicher, dass Sie diesen Rang löschen möchten? Diese Aktion ist unwiderruflich!',

    addIncidentType: 'Neuen Vorfallstyp hinzufügen',
    incidentTypes: 'Vorfallarten',
    categories: 'Kategorien',
    reasons: 'Gründe',
    places: 'Orte',
    response: 'Antwort',
    incidentCategory: 'Vorfallkategorie',
    incidentReason: 'Vorfallgrund',
    incidentPlace: 'Vorfallort',
    incidentResponse: 'Vorfallsantwort',
    servicesToContact: 'Zu kontaktierende Dienste',
    addService: 'Dienst hinzufügen',
    noService: 'Derzeit ist kein Dienst mit diesem Vorfallstyp verbunden',
    noServiceAvailable: 'Keine Dienste verfügbar',
    noResponse: 'Derzeit ist keine Antwort mit diesem Vorfallstyp verbunden',
    or: 'oder',

    interventionGroups: 'Einsatzgruppen',
};
